import React from "react";
import { Helmet } from "react-helmet";

const SEOHelmet = ({
  title = "Dịch Vụ Chuyển Âm Support | Chuyển Âm Thanh Sang Word bằng AI",
  description = "Nền tảng AI giúp Dịch Vụ Chuyển Âm chuyển đổi file ghi âm thành văn bản (file Word) nhanh chóng để tạo Vi Bằng, hỗ trợ định danh người nói và gán nhãn thời gian chính xác.",
  keywords = "Dịch Vụ Chuyển Âm, vi bằng, chuyển âm thanh, ghi âm thành văn bản, AI",
  author = "Dịch Vụ Chuyển Âm Support",
  canonical,
  ogImage,
  ogType = "website",
  twitterCard = "summary_large_image",
  noIndex = false,
  siteUrl = "https://dichvuchuyenam.com/",
}) => {
  // Tạo URL canonical nếu không được cung cấp
  const canonicalUrl = canonical || `${siteUrl}${window.location.pathname}`;

  // Tạo URL cho hình ảnh OG nếu không được cung cấp
  const ogImageUrl = ogImage || `${siteUrl}/logo512.png`;

  // Tạo thẻ meta robots
  const robotsContent = noIndex ? "noindex, nofollow" : "index, follow";

  return (
    <Helmet>
      {/* Meta tags cơ bản */}
      <title>{title}</title>
      <meta name="description" content={description} />
      {keywords && <meta name="keywords" content={keywords} />}
      <meta name="author" content={author} />
      <link rel="canonical" href={canonicalUrl} />

      {/* Open Graph tags */}
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:type" content={ogType} />
      <meta property="og:url" content={canonicalUrl} />
      <meta property="og:image" content={ogImageUrl} />
      <meta property="og:site_name" content="Dịch Vụ Chuyển Âm Support" />

      {/* Twitter Card tags */}
      <meta name="twitter:card" content={twitterCard} />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={ogImageUrl} />

      {/* Robots */}
      <meta name="robots" content={robotsContent} />

      {/* Thẻ bổ sung */}
      <meta name="theme-color" content="#4285f4" />
      <link rel="icon" type="image/x-icon" href={`${siteUrl}/favicon.ico`} />
    </Helmet>
  );
};

export default SEOHelmet;
